import React from 'react';
import { Badge, BadgeProps } from '@/components/atoms/Badge/Badge';
import { Container, Subtitle } from './BadgeSubtitleCell.style';

export type BadgeSubtitleCellProps = {
    badge: BadgeProps;
    subtitle?: string;
};

export const BadgeSubtitleCell: React.FunctionComponent<BadgeSubtitleCellProps> = ({ badge, subtitle }) => {
    return (
        <Container>
            <Badge {...badge} />
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Container>
    );
};
